export const COPILOT_INITIALIZE_OPEN = 'copilot-initialize-open';
export const getShouldStartWithCopilotOpen = () => {
  try {
    return sessionStorage.getItem(COPILOT_INITIALIZE_OPEN) === 'true';
  } catch (e) {
    return false;
  }
};